export var DEPLOY_DATE = new Date('2026-03-05T09:57:13+0000');
